import { motion } from "framer-motion";

const IMG = "/ops-photo-consultant.png";

export default function OpsCustom() {
  return (
    <section data-testid="section-custom" className="relative bg-[#1A2E4A] text-[#F1ECE0] border-t border-white/5 overflow-hidden">
      <div className="absolute -top-40 -right-40 h-[500px] w-[500px] rounded-full bg-[#D9FF3C]/8 blur-[140px] pointer-events-none" />
      <div className="relative max-w-[1400px] mx-auto px-6 md:px-12 py-20 md:py-28">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14 items-center">
          <motion.div initial={{ opacity: 0, scale: 0.96 }} whileInView={{ opacity: 1, scale: 1 }} viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="lg:col-span-6 order-2 lg:order-1"
          >
            <div className="relative overflow-hidden border border-white/10">
              <img
                src={IMG}
                alt="Ghanaian consultant discussing dashboard with a business owner"
                data-testid="custom-image"
                className="w-full h-[420px] md:h-[540px] object-cover"
              />
              <div className="absolute top-4 left-4 bg-[#D9FF3C] text-[#142645] px-3 py-1.5 text-[10px] font-plex-mono uppercase tracking-[0.22em] font-semibold">
                Built for you
              </div>
            </div>
          </motion.div>

          <div className="lg:col-span-6 order-1 lg:order-2">
            <motion.div initial={{ opacity: 0, y: 10 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
              className="text-[11px] uppercase tracking-[0.25em] font-semibold text-[#D9FF3C] mb-6 inline-flex items-center gap-2">
              <span className="inline-block h-1.5 w-1.5 rounded-full bg-[#D9FF3C]" />
              Customised for you
            </motion.div>

            <motion.h2 initial={{ opacity: 0, y: 16 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
              transition={{ duration: 0.7 }}
              className="font-editorial text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight"
            >
              Every business is different.
              <br />
              <span className="italic">Your dashboard should be too.</span>
            </motion.h2>

            <p className="mt-8 text-base md:text-lg text-[#F1ECE0]/75 leading-relaxed max-w-lg">
              Unlike off-the-shelf reporting systems, OpsIQ develops customised Operational
              Intelligence solutions designed around your business processes, goals, and
              performance indicators.
            </p>
            <p className="mt-4 text-base md:text-lg text-[#F1ECE0]/75 leading-relaxed max-w-lg">
              Whether you need one dashboard or an enterprise-wide solution, we build it to
              fit your organisation.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
